import { GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { usePaginationRequest } from "hooks/useRequest";
import {
  IDeliveryBarcodeHistory,
  IGetDeliveryBarcodeHistoryRequest,
  IPaginateApiResponse,
} from "model";
import React, { useEffect, useState } from "react";
import { ReportApiService } from "services";
import { I18nTranslator, translations } from "utils/i18n";
import { useDeliveryHistoryContext } from "..";

interface IFinishProductListProps {
  request: IGetDeliveryBarcodeHistoryRequest;
  loading: boolean;
  result: IPaginateApiResponse<IDeliveryBarcodeHistory[]>;
}

const FinishProductList = (props: IFinishProductListProps) => {
  const {
    handleProductListChangePage,
    handleProductListPageSizeChange,
    handleSearchProductList,
  } = useDeliveryHistoryContext();
  const { request, loading, result } = props;
  const [getFinishProductList, setFinishProductList] = useState(request);
  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    if (!initialLoad) {
      setFinishProductList(request);
    }
  }, [request]);

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "strDeliveryDate",
      headerName: I18nTranslator(translations.report.deliveryDate),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "doImportCode",
      headerName: I18nTranslator(translations.report.DOImportCode),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "companyCode",
      headerName: I18nTranslator(translations.report.companyCode),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "companyName",
      headerName: I18nTranslator(translations.report.companyName),
      size: "full",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productLot",
      headerName: I18nTranslator(translations.report.productLot),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productCode",
      headerName: I18nTranslator(translations.report.productCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productDescription",
      headerName: I18nTranslator(translations.report.productName),
      size: "full",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productCodeOld",
      headerName: I18nTranslator(translations.report.productCodeOld),
      size: "small",
      align: "left",
    }),

    TableHelper.createCell({
      field: "doQuantity",
      headerName: I18nTranslator(translations.report.DOQuantity),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "quantity",
      headerName: I18nTranslator(translations.report.deliveredQuantity),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "cartonOddQuantity",
      headerName: I18nTranslator(translations.report.deliveredCartonQuantity),
      size: "small",
      align: "right",
    }),
  ];

  return (
    <AppTable<IDeliveryBarcodeHistory>
      loading={loading}
      data={result}
      columns={COLUMNS}
      actionColumnProps={{
        hideEdit: true,
      }}
      onSearch={handleSearchProductList}
      searchPlaceholder={"Tìm kiếm: Mã lô"}
      onChangePage={handleProductListChangePage}
      hideHeader
      removeActionColumn
      defaultHeaderTable={210}
      onPageSizeChange={handleProductListPageSizeChange}
      hideSearch
    />
  );
};

export default FinishProductList;
